import memberApi from "@/api/member";
import { SELECT_OPTION_CONFIG } from "@/utils/constant";

const state = {
  // 采购主体/集团...
  members: []
};

const mutations = {
  SET_MEMBER: (state, members) => {
    state.members = members;
  }
};

const actions = {
  getMemberList({ commit }) {
    return new Promise((resolve) => {
      memberApi.list().then((res) => {
        const members = res.data?.map((item) => {
          item[SELECT_OPTION_CONFIG.CODE] = item.id;
          item[SELECT_OPTION_CONFIG.LABEL] = item.name;
          return item;
        }) ?? [];
        commit("SET_MEMBER", members);
        resolve(members);
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
